import axios from "../../../services/axios-config.js";

export async function restoreUser({ userId }) {
    const res = await axios.post(`/admin/users/${userId}/restore`);
    return res?.data;
}
